import { type TFunction } from 'i18next';
import { allowedCountries, continentCodes } from '@/data/allowedCountries';

const getTranslatedVatCountriesObject = (
  t: TFunction<string[], undefined>,
  countryCodes: string[]
) => {
  const allowedCountryCodes = Object.keys(allowedCountries);
  const continentCountryMap: Record<
    string,
    { value: string; label: string }[]
  > = {};

  continentCodes.forEach((continentCode) => {
    const tContinent = t(`vatCountries:continent${continentCode}`);

    countryCodes
      .filter((code) => {
        return (
          allowedCountryCodes.includes(code) &&
          allowedCountries[code].continent === continentCode
        );
      })
      .forEach((code) => {
        if (!continentCountryMap[tContinent]) {
          continentCountryMap[tContinent] = [];
        }

        continentCountryMap[tContinent].push({
          value: code,
          label: t(`vatCountries:${code}`),
        });
      });
  });

  Object.keys(continentCountryMap).forEach((continent) => {
    continentCountryMap[continent].sort((countryA, countryB) => {
      return countryA.label.localeCompare(countryB.label);
    });
  });

  return continentCountryMap;
};

const getGroupedCountriesOptions = (
  t: TFunction<string[], undefined>,
  countryCodes: string[],
  pleaseChoose?: boolean
) => {
  const translatedVatCountries = getTranslatedVatCountriesObject(
    t,
    countryCodes
  );

  return (
    <>
      {pleaseChoose && (
        <option value="">{t('vatCountries:pleaseChoose')}</option>
      )}
      {Object.entries(translatedVatCountries).map(([continent, countries]) => {
        return (
          <optgroup label={continent} key={continent}>
            {countries.map(({ value, label }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              );
            })}
          </optgroup>
        );
      })}
    </>
  );
};

export default getGroupedCountriesOptions;
